// Config
import { getRouterLocation, getRouterPathname, getRouterSearch } from '@router/routerAdapter';

export const getRouterLocationSelector = () => getRouterLocation();
export const getRouterLocationPathname = () => getRouterPathname() ?? '';
export const getRouterLocationSearchSelector = () => getRouterSearch();
